import { render } from "./Moribund.vue?vue&type=template&id=876c4b40"
import script from "./Moribund.vue?vue&type=script&lang=js"
export * from "./Moribund.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__